// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__2Avwb","warningText":"styles_warningText__30pSD","grow":"styles_grow__3WaXI"};